import React from 'react'
import withView from '../../cmn/docAutomation/withView';
import FormROValue from '../../../library/form/components/FormROValue1';
import FormLabel from '../../../library/form/components/FormLabel'
import FormWrapper from '../../../library/form/components/FormWrapper'
import SarasTrans from '../../../library/notifications/SarasTrans';

const ProfileTrackHeader = (props) => {
    const { formObject } = props;

    return (
        <FormWrapper customWrapper="span" formObject={formObject} rowKey="" 
        wrapperClass="uiInlineErr uiFlexBox15" action={{ paramName: "container" }} >
            <div className='uiFlexBox3'>
                <span className="">
                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "lastPaidOn" }} value="Last Paid Date" />
                </span>
                <FormROValue format="#" className="uiHighlightBlue" formObject={formObject} rowKey="" action={{ paramName: "lastPaidOn" }} />
            </div>
            <div className='uiFlexBox3'>
                <span className="">
                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "outstanding" }} value="Total Outstanding" />
                </span>
                <FormROValue format="#" className="uiHighlightBlue" formObject={formObject} rowKey="" action={{ paramName: "outstanding" }} />
            </div>
            <div className='uiFlexBox3'>
                <span className="">
                    <SarasTrans value="Credit Days" />
                </span>
                <FormROValue format="#" className="uiHighlightBlue" formObject={formObject} rowKey="" action={{ paramName: "creditDays" }} />
                
                <FormWrapper customWrapper="" formObject={formObject} rowKey="" action={{ paramName: "creditDaysUsed" }} >
                    <span> (</span><FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "creditDaysUsed" }} /> %)
                </FormWrapper>
            </div>
            
            <div className='uiFlexBox3'>
                <span className="">
                    <SarasTrans value="Credit Limit" />
                </span>
                <FormROValue format="#" className="uiHighlightBlue" formObject={formObject} rowKey="" action={{ paramName: "creditLimit" }} />

                <FormWrapper customWrapper="" formObject={formObject} rowKey="" action={{ paramName: "creditLimitUsed" }} >
                    <span> (</span><FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "creditLimitUsed" }} /> %)
                </FormWrapper>
            </div>

        </FormWrapper>
    )
}

export default withView(ProfileTrackHeader, "proTrackHeader", "")